import React, { Component } from 'react'
import { Route, Switch } from 'react-router'
import Notifications from 'react-notify-toast'
// import Header from '../common/Header'
import ListEventsPage from '../Events/ListEventsPage'
import EventPage from '../Events/EventPage'
import RacePage from '../Races/RacePage'

class MainRouter extends Component {
  render () {
    return (
      <div>
        <Notifications />
        {/* <Header /> */}
        <Switch>
          <Route exact path='/' component={ListEventsPage} />
          <Route path='/page/:page' component={ListEventsPage} />
          <Route exact path='/:event' component={EventPage} />
          <Route exact path='/:event/:race' component={RacePage} />
          <Route path='/:event/:race/:sex' component={RacePage} />
        </Switch>
      </div>
    )
  }
}

export default MainRouter
